import { getCookie, CookieKeys } from "@lib/cookies";
import { useEffect, useState } from "react";
import { OnboardingScreens } from "./OnboardingScreens/OnboardingScreens";
import { coerceBoolean } from "@lib/coerceBoolean";
import { getIsInIframe } from "@lib/iframe";

const Onboarding = () => {
  const [showTutorial, setShowTutorial] = useState(false);

  useEffect(() => {
    (async () => {
      const cookieValue = await getCookie(
        CookieKeys.tutorialViewed,
        false,
        coerceBoolean,
      );

      if (cookieValue === false && !getIsInIframe()) {
        setShowTutorial(true);
      }
    })();
  }, []);

  if (!showTutorial) {
    return null;
  }

  return <OnboardingScreens />;
};

export { Onboarding };
